import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const BottomNav: React.FC = () => {
  const { t } = useTranslation();
  
  
  const navItems = [
    {
      path: '/home',
      label: t('common.screenNames.home'),
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
          />
        </svg>
      ),
    },
    {
      path: '/training',
      label: t('glossary.training'),
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
          />
        </svg>
      ),
    },
    {
      path: '/add',
      label: t('glossary.add'),
      icon: (
        <div
          className="bg-primary text-white rounded-full h-12 w-12 flex items-center justify-center"
          style={{
            position: 'relative',
            top: '-4px', // Slight lift but stays within bounds
            pointerEvents: 'none' // Let parent NavLink handle clicks
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-8 w-8"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 4v16m8-8H4"
            />
          </svg>
        </div>
      ),
    },
    {
      path: '/coach',
      label: t('glossary.coach') || 'Coach',
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
          />
        </svg>
      ),
    },
    {
      path: '/more',
      label: t('glossary.more'),
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 6h16M4 12h16M4 18h16"
          />
        </svg>
      ),
    },
  ];

  return (
    <>
      {/* Background extension for safe area */}
      <div
        className="bg-white dark:bg-gray-800"
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          height: 'max(env(safe-area-inset-bottom), 20px)',
          zIndex: 99998
        }}
      />

      {/* Navigation bar */}
      <nav
        className="bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700"
        style={{
          position: 'fixed',
          bottom: 'max(env(safe-area-inset-bottom), 20px)',
          left: 0,
          right: 0,
          zIndex: 99999,
          WebkitTouchCallout: 'none',
          WebkitUserSelect: 'none',
          touchAction: 'manipulation',
          pointerEvents: 'auto' // Ensure nav can receive clicks
        }}
      >
        <div className="flex justify-around items-center" style={{ height: '56px' }}>
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center flex-1 h-full py-1 px-2 transition-colors active:scale-95 ${
                  isActive
                    ? 'text-primary dark:text-primary-400'
                    : 'text-gray-500 dark:text-gray-400'
                }`
              }
              style={{
                WebkitTapHighlightColor: 'transparent',
                minHeight: '56px',
                minWidth: '60px',
                pointerEvents: 'auto', // Explicit pointer handling
                cursor: 'pointer'
              }}
            >
              {item.icon}
              <span className="text-xs mt-0.5">{item.label}</span>
            </NavLink>
          ))}
        </div>
      </nav>
    </>
  );
};

export default BottomNav;